import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { Typography } from '@telus-uds/components-web';
import { getContentfulData, contentfulFormConfig, getData } from './contentful';
import { replace, getPathVariables } from './misc';
import Dashboard from './dashboard';
import Form from './form';
import { useLocalizedStringsContext } from './context/LocalizedStringsContext';
import { useLocaleContext } from './context/LocaleContext';

const retiredWlnCategoryName = 'wireline and secure business';

const App = ({ history, location: { pathname, search } }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      FORM: {
        MESSAGE: { LOADING }
      }
    }
  } = localizedStrings;

  const [categories, setCategories] = useState(null);
  const [categoriesForSummary, setCategoriesForSummary] = useState(null);
  const [, categoryName, formName] = getPathVariables(pathname);
  const locale = useLocaleContext();
  const { orderId, step, isEditing } = queryString.parse(search);
  const config = { ...contentfulFormConfig, locale };
  const configForSummary = {...contentfulFormConfig, locale: locale === 'en-US' ? 'fr-CA' : 'en-US'};
  const findItem = (items, name) =>
    items.filter(
      item =>
        replace(_.get(item, 'fields.name', '')).toLowerCase() ===
        name.toLowerCase()
    );

  useEffect(() => {
    getContentfulData(config).then(res => {
      const { formCategories } = getData(res);
      setCategories(
        formCategories.filter(
          category =>
            category.metadata &&
            _.get(category, 'fields.name', '').trim().toLowerCase() !==
              retiredWlnCategoryName
        )
      );
    });
    getContentfulData(configForSummary).then(res => {
      const { formCategories } = getData(res);
      setCategoriesForSummary(
        formCategories.filter(
          category =>
            category.metadata &&
            _.get(category, 'fields.name', '').trim().toLowerCase() !==
              retiredWlnCategoryName
        )
      );
    });
  }, [locale]);

  if (!categories) return <Typography block>{LOADING}</Typography>;
  if(!categoriesForSummary) return <Typography block>{LOADING}</Typography>;

  if (categoryName) {
    const currentCategory = findItem(categories, categoryName);
    const currentCategoryForSummary = findItem(categoriesForSummary, categoryName);
    if (currentCategory.length) {
      const {
        fields: { forms }
      } = currentCategory[0];
      const currentForm = findItem(forms, formName);
      const currentFormForSummary = findItem(currentCategoryForSummary[0].fields.forms, formName);
      if (currentForm.length === 1) {
        return (
          <Form
            data={currentForm[0]}
            orderId={orderId}
            isEditing={isEditing}
            initialStep={step}
            history={history}
            dataSummary={currentFormForSummary[0]}
          />
        );
      }
    } else {
      history.push('/');
    }
  }

  return (
    <Dashboard categories={categories} locale={locale} history={history} />
  );
};

App.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired
};

export default App;
